
import { SimilarCompaniesResponse, convertToCSV } from '../../../services/openai';

/**
 * Trigger a CSV download from the similar companies data
 * @param data The similar companies data
 * @param filename The name of the file to download (without extension)
 */
export const downloadCSV = (data: SimilarCompaniesResponse, filename: string = 'similar_companies'): void => {
  try {
    // Convert data to CSV format
    const csvData = convertToCSV(data);
    
    // Create a Blob with the CSV data
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    
    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.csv`);
    
    // Append the link to the document
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading CSV:', error);
    throw error;
  }
};
